// import LandingModel from '../models/landing.model'
let storeContent = utils.generateStore({
	// LandingModel,
	articles: [],
	testimonials: [],
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		openAccordion(ctx, number) {
			ctx.commit('activeAccordion', number);
		},
		async fetchQuotes(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'forgot_password',
							action: 'request',
							data: {
								username: data.email,
							},
						},
						'/home',
					);

					await $session.set('requestID', res.result.requestId);
					$notify(
						'success',
						'OTP Sent',
						`OTP has been sent to your phone number`,
						10,
					);
					ctx.commit('page', 3);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchTestimonials(ctx) {
			ctx.commit('testimonials', [
				{
					image: '/img/avatar2.jpg',
					title: 'Magically better handoffs from design to development',
					desc: 'From its medieval origins to the digital era lorem ipsum dolor sit amet',
					name: 'John Doe',
					position: 'Co-Founder Mastercard',
				},
				{
					image: '/img/avatar2.png',
					title: 'This is a new title for User 2',
					desc: 'From its medieval origins to the digital era lorem ipsum dolor sit amet',
					name: 'John Doe',
					position: 'Co-Founder Mastercard',
				},
				{
					image: '/img/avatar1.jpg',
					title: 'This is a new title for User 3',
					desc: 'From its medieval origins to the digital era lorem ipsum dolor sit amet',
					name: 'John Doe',
					position: 'Co-Founder Mastercard',
				},
			]);
		},
		async fetchArticles(ctx) {
			ctx.commit('articles', [
				{
					image: '/img/img1.jpg',
					title: 'News',
					desc: 'From its medieval origins to the digital era lorem ipsum dolor sit amet',
					uploader: 'John Doe',
					icon: 'fa fa-box',
					date: 'Set 4, 2019',
				},
				{
					image: '/img/img2.jpg',
					title: 'News',
					desc: 'From its medieval origins to the digital era lorem ipsum dolor sit amet',
					uploader: 'John Doe',
					icon: 'fa fa-box',
					date: 'Set 4, 2019',
				},
				{
					image: '/img/img3.jpg',
					title: 'News',
					desc: 'From its medieval origins to the digital era lorem ipsum dolor sit amet',
					uploader: 'John Doe',
					icon: 'fa fa-box',
					date: 'Set 4, 2019',
				},
			]);
		},
		async fetchData(ctx) {
			await ctx.dispatch('fetchArticles');
			await ctx.dispatch('fetchTestimonials');
			Event.$emit('loader:show', false);
		},
	},
};
